import * as React from 'react';
import styles from './Contact.module.css';

interface ContactProps {
  lang: 'en' | 'it';
}

/**
 * Contact Component
 * 
 * Displays contact information including email, phone, and personal details.
 */
const Contact: React.FC<ContactProps> = ({ lang }) => (
  <section id="contact" className={styles.contactSection}>
    <h2 className={styles.title}>{lang === 'en' ? 'Contact' : 'Contatti'}</h2>
    <p className={styles.infoItem}><strong className={styles.label}>{lang === 'en' ? 'Email:' : 'Email:'}</strong> <a href="mailto:Lorenzo.quadrelli.00@ik.me" className={styles.link}>Lorenzo.quadrelli.00@ik.me</a></p>
    <p className={styles.infoItem}><strong className={styles.label}>{lang === 'en' ? 'Phone:' : 'Telefono:'}</strong> <a href="tel:+393347774631" className={styles.link}>+39 334 777 4631</a></p>
    <p className={styles.infoItem}><strong className={styles.label}>{lang === 'en' ? 'Born:' : 'Nato il:'}</strong> 10/07/2000</p>
    <p className={styles.infoItem}><strong className={styles.label}>{lang === 'en' ? 'Nationality:' : 'Nazionalità:'}</strong> {lang === 'en' ? 'Italian' : 'Italiana'}</p>
    <p className={styles.infoItem}><strong className={styles.label}>{lang === 'en' ? 'Languages:' : 'Lingue:'}</strong> {lang === 'en' ? 'Italian (native), Professional English (IELTS C1, score 7.5), Basic French (DELF A2)' : 'Madrelingua italiano, Inglese professionale (IELTS C1, score 7.5), Francese base (DELF A2)'}</p>
  </section>
);

export default Contact;
